export const manifest = {
  screens: {
    scr_g094e2: { name: "Landing VCARS", route: "/", state: {"slideIndex":0}, position: {"x":160,"y":220} },
  },
  sections: {
    sec_z616vz: { name: "Hero & Onboarding", x: 0, y: 0, width: 4320, height: 1180 },
    sec_trrol4: { name: "Value Proposition", x: 0, y: 1980, width: 5720, height: 1180 },
    sec_weehxg: { name: "Call to Action", x: 0, y: 3960, width: 1520, height: 1180 },
    sec_5k9dk5: { name: "Social Proof & Urgency", x: 0, y: 5940, width: 2920, height: 1180 },
    sec_fi4k4q: { name: "FAQ Section", x: 0, y: 7920, width: 2920, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_z616vz", children: [
      { kind: "screen", id: "scr_g094e2" },
      { kind: "screen", id: "scr_vc0002" },
      { kind: "screen", id: "scr_vc0003" },
    ] },
    { kind: "section", id: "sec_trrol4", children: [
      { kind: "screen", id: "scr_vc0004" },
      { kind: "screen", id: "scr_vc0005" },
      { kind: "screen", id: "scr_vc0006" },
      { kind: "screen", id: "scr_vc0008" },
    ] },
    { kind: "section", id: "sec_weehxg", children: [
      { kind: "screen", id: "scr_vc0007" },
    ] },
    { kind: "section", id: "sec_5k9dk5", children: [
      { kind: "screen", id: "scr_vc0011" },
      { kind: "screen", id: "scr_vc0012" },
    ] },
    { kind: "section", id: "sec_fi4k4q", children: [
      { kind: "screen", id: "scr_vc0009" },
      { kind: "screen", id: "scr_vc0010" },
    ] },
  ],
}
